import React, {forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useRef, useState} from "react";
import {IconClose, IconJournal, IconLinkJournal, IconLinkNote, IconNote, IconProject} from "../../Icon";
import {ConfigProvider, Dropdown, Input, Modal, Tree} from "antd";
import {t} from "i18next";
import {
    countWords,
    decodeDeeplink,
    formatDate,
    formatSize,
    generateUUID2,
    getImagePathWithTheme, getImagePathWithThemeSvg, getInfoDateDesc, hasInfoNotes,
    imgPathPerfix, isAnnoElement, isAnnoType, isAudioFileElement, isDeepLink, isFileElement,
    isFileVideoElement, isInDraw, isInSidebar, isLiveVideoElement,
    isNoteElement,
    isPdfFileElement, isString, isSupportVideoAnnoUrl,
    removeHtmlTagsWithSpace,
} from "../../utils";
import {
    getNoteById,
    getNoteDoc,
    getNoteJsonDoc,
    getNoteList,
    staticLibraryRefInProject,
    updateNote
} from "../../../model/note";
import {getCardById, getCardDoc, getCardList, updateCard} from "../../../model/card";
import {ipcInvoke, ipcSend} from "../../common/ipc";
import {
    isEmbedableBookmarkElement,
    isImageElement,
    isMindmapElement,
    isProjectLinkElement
} from "../../../@excalidraw/packages/excalidraw/element/typeChecks";
import {
    EVENT_NOTE_CHANGED,
    EVENT_OPEN_LIBRARY_ITEM,
    EVENT_PROJECT_ON_SlIDER_RIGHT,
    EVENT_REDICTER_TO_DRAW,
    EVENT_REFRESH_INFO_TAG,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_RESET_NO_SELECTED,
    EVENT_SHOW_DIALOG_DRAWINDEX,
    FROM_LIBRARY,
    FROM_RIGHT_SIDEBAR,
    getInputBorderColor,
    KEY_FILE_DIR
} from "../../Const";
import DialogTagManager from "../Dialog/DialogTagManager";
import {postMessage, recvMessage, unSubscribe} from "../../common/event";
import {CaretDownOutlined, DownOutlined} from "@ant-design/icons";
import {TreeProps} from "antd/es/tree";
import {FieldDataNode} from "rc-tree/lib/interface";
import {staticProject} from "../../UtilityInner";
import {APP_WEB} from "@/electron_interactive";
import {closeEditor, openEditor} from "@/state";
import {deepLinkToLinkInfo, getDrawPath, isSupportLink} from "@/Utility";
import {dbGetHighlight} from "@model/highlight";
import Global from "@/global";
import {findNodeWithParents, loopAllNode, loopAllNodeAsync} from "@/TreeUtils";
import global from "@/global";
import CustomPropertyInfo from "@/views/Property/CustomPropertyInfo";
import CustomDeeplink from "@/views/Property/CustomDeeplink";
import {updateBoard} from "@model/board";
const {DirectoryTree} = Tree;

type DataNode = FieldDataNode<{
    key:string;
    title?:string;
    isFolder:boolean;
    children?:any;
    icon:any;
    isHover?:boolean;
    from?:any;
}>

let mData:any;

const LibraryInfos = forwardRef((props:{height:any,from?:any}, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog,
    }))

    const [type,setType] = useState('');
    const [isShowDialog,setIsShowDialog] = useState(false);
    const [data,setData] = useState<any>();
    const [arrayAttributes,setArrayAttributes] = useState([]);
    const [arrayTags,setArrayTags] = useState([]);
    const [arrayBeyondProjects,setArrayBeyondProjects] = useState([]);
    const [arrayLinkDatas,setArrayLinkData] = useState([]);
    const [arrayBacklinkDatas,setArrayBacklinkDatas] = useState([]);
    const [isEditInfoUrl,setIsEditInfoUrl] = useState(false);

    const dialogTagManagerRef = useRef(null);
    const dataRef = useRef<any>(null);

    const txtAreaRef = useRef(null);
    const selfGuid = useRef(null);
    const inputDivRef = useRef(null);
    const mProjectLinkIds = useRef<any>([]);
    const statIds = useRef<any>({});

    useEffect(()=>{
        global.g_mapLibraryInfos = {};

        if (!selfGuid.current){
            selfGuid.current = generateUUID2();
        }

        recvMessage(EVENT_REFRESH_INFO_TAG,(msg,data1)=>{
            refreshTag(mData);
        })

        return ()=>{
            unSubscribe(EVENT_REFRESH_INFO_TAG);
        }
    },[])

    useEffect(() => {
        dataRef.current = data;
        if (!selfGuid.current){
            selfGuid.current = generateUUID2();
        }
        window.refreshList['refreshLibraryInfos_'+selfGuid.current] = (data0,extra)=>{
            if (!data0)return;
            const ddd = dataRef.current || data;
            if (data0?.id == ddd?.id && selfGuid.current != extra?.guid){
                const newData = {...ddd,infoNotes:data0.infoNotes,infoUrl:data0.infoUrl};
                setData(newData);
            }
        }
        return ()=>{
            delete window.refreshList['refreshLibraryInfos_'+selfGuid.current];
        }

    }, [data]);


    useEffect(() => {
        refreshTextAreaHeight(txtAreaRef.current,false);
    }, [txtAreaRef.current]);

    const onShowDialog = async (szType:string,data0:any,isSimpleRefresh=false)=>{
        if (!data0) {
            return;
        };
        if (data0.id == data?.id){
            return;//同一个....
        }

        if (data?.id){
            global.g_mapLibraryInfos[data.id] = false;
        }
        global.g_mapLibraryInfos[data0.id] = true;

        if (data0.infoUrl && !data0.infoUrl.startsWith('http') && !isDeepLink(data0.infoUrl) && !isSupportLink(data0.infoUrl)){
            data0.infoUrl = 'https://'+data0.infoUrl;
        }

        setIsShowDialog(true);
        setType(szType);
        setData(data0);
        mData = data0;
        if (!isSimpleRefresh){
            setArrayBeyondProjects([])
        }
        if (txtAreaRef.current){
            refreshTextAreaHeight(txtAreaRef.current,false);
        }

        //列表数据
        let szSize:any = '0MB';
        var projectAttr:any;
        let szAttachDesc = '';
        if (szType == 'project') {
            projectAttr = await staticProject(data0);
            szSize = projectAttr.formatSize;
            if (projectAttr.cards > 0){
                szAttachDesc += projectAttr.cards + ' ' + t('Cards') + ', '
            }
            if (projectAttr.pdfs > 0){
                szAttachDesc += projectAttr.pdfs + ' ' + t("PDFs") + ', '
            }
            if (projectAttr.videos > 0){
                szAttachDesc += projectAttr.videos + ' ' + t("Videos") + ', ';
            }
            if (projectAttr.files > 0){
                szAttachDesc += projectAttr.files + ' ' + t("Files") + ', '
            }
            if (szAttachDesc){
                szAttachDesc = szAttachDesc.substring(0,szAttachDesc.length - 2);
            }

        }else if (szType == 'library'){
            if (data0.type == 'card'){
                if (!data0.doc){
                    data0.doc = await getCardDoc(data0.id);
                }
                let nSize = data0.doc.length;
                szSize = formatSize(nSize);
            }else{
                let szDir:any = '';
                if (!data0.isAbsolutePath){
                    szDir = localStorage.getItem(KEY_FILE_DIR);
                }
                let nSize = await ipcInvoke('get-file-size', {filePath:szDir +data0.fileName});
                szSize = formatSize(nSize);
            }
        }

        var arrays:any = [
            {
                key:'created',
                label:t("Created"),
                icon:'info_date.svg',
                value:getInfoDateDesc(data0.createTime)//formatDate(data.createTime,'yyyy-MM-dd　　hh:mm')
            },
            {
                key:'updated',
                label:t("Updated"),
                icon:'info_date.svg',
                value:getInfoDateDesc(data0.highlight?data0.highlight.updateTime:(data0.updateTime1 || data0.updateTime))//formatDate(data.updateTime,'yyyy-MM-dd　　hh:mm')
            },
            // {
            //     key:'size',
            //     label:t("Size"),
            //     value:szSize
            // }
        ];

        if (szType == 'library' && (data0.type == 'card' || data0.type == 'journal' || data0.type == 'youtube' || data0.type == 'bilibili' || data0.type == 'videoAnno' || data0.type == 'pdfAnno' || data0.type == 'audioAnno' || data0.type == 'cardAnno' || data0.type == 'webLink')){

        }else{//card 不要size
            arrays.push({
                key:'size',
                label:t("Size"),
                value:szSize,
                icon:'info_size.svg'
            })
        }

        if (szType == 'library'){
            if (data0.type == 'card' || data0.type == 'journal'){
                if (!data0.doc){
                    data0.doc = await getCardDoc(data0.id);
                }
                const szContent = removeHtmlTagsWithSpace(data0.doc);
                // const words = szContent.match(/\w+/g);
                let nWordsCount = countWords(szContent) + countWords(data0.name);// words ? words.length : 0
                arrays.push({
                    key:'wordCount',
                    label:t("Word count"),
                    icon:'info_card_stat.svg',
                    value: nWordsCount + ' ' + t("Stat Words") + ', ' + (szContent.trim().length + data0.name?.length || 0) + ' ' + t("Stat Characters")
                })

                //这里统计card。。。这里统计card。。。这里统计card。。。这里统计card。。。这里统计card。。。这里统计card。。。这里统计card。。。这里统计card。。。这里统计card。。。这里统计card。。。这里统计card。。。
                var arrayLinks:any = [];
                statCardLink(data0,arrayLinks,null).then(res=>{
                    if (global.g_mapLibraryInfos[data0.id]){
                        setArrayLinkData(arrayLinks);
                    }
                });

            }else if (data0.type == 'videoAnno' || data0.type == 'pdfAnno' || data0.type == 'audioAnno' || data0.type == 'cardAnno'){
                let szImgName = 'info_source_pdf';
                if (data0.type == 'videoAnno' || data0.type == 'audioAnno'){
                    szImgName = 'info_source_video';
                    let nWordsCount = countWords(data0.title) + countWords(data0.content);
                    arrays.push({
                        key:'wordCount',
                        label:t("Word count"),
                        icon:'info_card_stat.svg',
                        value: nWordsCount + ' ' + t("Stat Words") + ', ' + (data0.content.trim().length + data0.title?.length || 0) + ' ' + t("Stat Characters")
                    })
                }else if (data0.type == 'cardAnno'){
                    szImgName = "info_link_card";
                }

                const library = await getCardById(data0.libraryId);

                if (library){
                    arrays.push({
                        key:'source',
                        label:t("Source"),
                        icon:'info_source.svg',
                        value:<div className={'flex-row-vertical-center cursor-pointer'} onClick={async ()=>{
                            if (data0.type == 'videoAnno' || data0.type == 'audioAnno'){
                                const highlight = await dbGetHighlight(data0.libraryId);
                                if (highlight){
                                    window.showVideoNotes(highlight,data0.id);
                                }
                            }else if (data0.type == 'pdfAnno'){
                                const library = await getCardById(data0.libraryId);
                                if (library){
                                    window.showPdfPreview(library.name,library.id,library.fileName,false,false,true,{highlightId:data.id})
                                }
                            }else if (data0.type == 'cardAnno'){
                                setIsShowDialog(false);//关闭
                                window.closeDialogPdfAnno();

                                Global.g_currentNoteData = library;
                                // Global.g_isNotePopupWindow = true;
                                setTimeout(() => {
                                    openEditor(library.id, true)
                                }, 40);
                            }

                            setIsShowDialog(false);
                        }}><img className={'img-14'} src={getImagePathWithTheme(szImgName)}/><span className={'ml-6 span-single-line'} style={{display:'block',width:'300px',marginTop:'2.5px'}}>{library.name || library.fileName || library.src || t("Untitled")}</span></div>
                    })
                }
            }


            if (!isSimpleRefresh){
                //所在的project--只第一次查找。后续的输入不再查找....太卡，右侧栏返回library的时候太慢
                const arrayProjects:any = await staticLibraryRefInProject(data0.id,true);
                if (arrayProjects && arrayProjects.length > 0){
                    let szProjects = '';
                    arrayProjects.forEach((p)=>{
                        szProjects += p.name + ',';
                    })
                    if (szProjects){
                        szProjects = szProjects.substring(0,szProjects.length - 1);
                    }
                    //继续查找所在的broad
                    for (let i=0;i<arrayProjects.length;i++){
                        const jsonDoc = JSON.parse(arrayProjects[i].doc);
                        // if (jsonDoc.canvas.length == 1)continue;

                        let isFinished = false;
                        await loopAllNodeAsync(jsonDoc.canvas,async (board:any)=>{
                            if (!isFinished && board.drawJson?.elements){
                                const arrayElements = board.drawJson.elements;
                                const isExist = arrayElements.some(p=>/*p.customData?.generationData?.id == data.id ||*/
                                    p.customData?.generationData?.pdfData?.id == data0.id ||
                                    p.customData?.generationData?.videoData?.id == data0.id ||
                                    p.id == data0.id ||
                                    (isNoteElement(p) && p.customData?.generationData?.id == data0.id) ||
                                    (isPdfFileElement(p) && p.customData?.generationData?.id == data0.id) ||
                                    (isFileVideoElement(p) && p.customData?.generationData?.id == data0.id) ||
                                    (isAudioFileElement(p) && p.customData?.generationData?.id == data0.id) ||
                                    (isImageElement(p) && p.customData?.generationData.id == data0.id) ||
                                    (isFileElement(p) && p.customData?.generationData.id == data0.id) ||
                                    (isEmbedableBookmarkElement(p) && p.customData?.generationData.id == data0.id)||
                                    (isLiveVideoElement(p) && p.customData?.generationData?.id == data0.id));
                                arrayProjects[i].isExist = isExist;
                                if (isExist){//不是第一个.
                                    if (board.key != jsonDoc.canvas[0].key){
                                        arrayProjects[i].boardId = board.key;
                                        const parents = findNodeWithParents(jsonDoc.canvas,board.key);
                                        let szTitle = '';
                                        if (parents.parents){
                                            for (let p=0;p<parents.parents.length;p++){
                                                szTitle += parents.parents[p].title + ' / ';
                                            }
                                        }
                                        szTitle += board.title;

                                        arrayProjects[i].boardName = szTitle;
                                    }
                                    isFinished = true;
                                }
                            }
                        })
                    }
                    if (global.g_mapLibraryInfos[data0.id]) {
                        setArrayBeyondProjects(arrayProjects.filter(p => p.isExist));
                    }
                }

                //backcard link
                backCardList(data0).then(res=>{
                    if (global.g_mapLibraryInfos[data0.id]) {
                        setArrayBacklinkDatas(res);
                    }
                })
            }
        }

        //x cards, x PDFs, x Videos, x Audios, x Files
        if (szType == 'project'){
            if (szAttachDesc){
                arrays.push({
                    key:'content',
                    label:t("Content"),
                    value:szAttachDesc,
                    icon:'info_project.svg',
                })
            }

            //这里统计project
            var arrayLinks:any = [];
            statProjectLink(data0,arrayLinks,null,data0.id).then(res=>{
                if (global.g_mapLibraryInfos[data0.id]) {
                    setArrayLinkData(arrayLinks);
                }
            });

            //backcard link
            backProjectList(data0).then(res=>{
                if (global.g_mapLibraryInfos[data0.id]) {
                    setArrayBacklinkDatas(res);
                }
            })
        }

        setArrayAttributes(arrays);

        //tags
        refreshTag(data0);
    }

    /**
     * 刷新标签
     */
    const refreshTag = async (data:any)=>{
        var arrayNewTags:any = [];
        if (data?.tags){
            data.tags.forEach(p=>{
                arrayNewTags.push({
                    name:p,
                })
            })
        }
        setArrayTags(arrayNewTags);
    }

    /**
     * 找 card 的链接....
     * @param card
     */
    async function statCardLink(card:any,arrayLinkNodes:any,childNode:any){
        if (!card.doc){
            card.doc = await getCardDoc(card.id);
        }
        let pattern = /<deeplink(.*?)<\/deeplink>/g;
        let results = card.doc.match(pattern);
        if (results){
            const parser = new DOMParser();
            for (let i=0;i<results.length;i++){
                //获取标题和链接
                const szStr = results[i];
                const xmlDoc = parser.parseFromString(szStr,'text/xml');
                const deeplinkTag = xmlDoc.getElementsByTagName('deeplink')[0];
                if (deeplinkTag){
                    const szName = deeplinkTag.getAttribute('text');
                    const szHref:any = deeplinkTag.getAttribute('href');
                    const deeplink = decodeDeeplink(szHref);
                    if (deeplink.childType == 'card' || deeplink.childType == 'journal'){
                        const dbCard:any = await getCardById(deeplink.id,true);
                        const node = {
                            key:generateUUID2(),
                            title:dbCard?.name || t("Untitled"),
                            icon:deeplink.childType == 'card'?<IconLinkNote/>:<IconLinkJournal/>,
                            children:[],
                            type:dbCard.type,
                            deeplink,
                        }
                        // const childCard = await getCardById(deeplink.id)
                        if (arrayLinkNodes){
                            arrayLinkNodes.push(node);
                        }else{
                            childNode.children.push(node);
                        }
                        //找下一级
                        if (!statIds.current[dbCard.id]){
                            statIds.current[dbCard.id] = true;
                            await statCardLink(dbCard,null,node)
                        }
                    }
                }
            }
        }
    }
    /**
     * 引用
     * @param card
     */
    async function backCardList(card:any){
        const arrayBackLinks:any = [];
        let arrayCards:any = await getCardList(-1,0,'card','','');
        let arrayJournal:any = await getCardList(-1,0,'journal','','');
        arrayCards.push(...arrayJournal);

        for (let i=0;i<arrayCards.length;i++){
            const item = arrayCards[i];
            if (item.id == card.id)continue;

            item.doc = await getCardDoc(item.id);
            const htmlDoc = new DOMParser().parseFromString(item.doc, 'text/html');
            const deeplinkTags = htmlDoc.getElementsByTagName('deeplink');
            const addedParagraphIds = new Set<string>();
            for (let j = 0; j < deeplinkTags.length; j++){
                const deeplinkTag = deeplinkTags[j];
                const szHref:any = deeplinkTag.getAttribute('href');
                if (!szHref) continue;
                const deeplink = decodeDeeplink(szHref);
                if (deeplink.childType == 'card' && deeplink.id == card.id){
                    // 找最近的有 data-id 的祖先块节点作为跳转目标
                    let parent = deeplinkTag.parentElement;
                    let paragraphId = null;
                    while (parent && parent.tagName !== 'BODY'){
                        if (parent.hasAttribute('data-id')){
                            paragraphId = parent.getAttribute('data-id');
                            break;
                        }
                        parent = parent.parentElement;
                    }
                    if (paragraphId && !addedParagraphIds.has(paragraphId)){
                        addedParagraphIds.add(paragraphId);
                        const node = {
                            key:generateUUID2(),
                            title:item.name,
                            icon:<IconNote/>,
                            children:[],
                            type:item.type,
                            deeplink:{
                                id:item.id,
                                targetCardId:card.id,
                                blockId:paragraphId,
                                blockType:'paragraph',
                            },
                        }
                        arrayBackLinks.push(node);
                    }
                }
            }

            //继续查找别的。。。
            let pattern = /<deeplink(.*?)<\/deeplink>/g;
            let results = item.doc.match(pattern);
            if (results){
                const parser = new DOMParser();
                for (let i=0;i<results.length;i++){
                    //获取标题和链接
                    const szStr = results[i];
                    const xmlDoc = parser.parseFromString(szStr,'text/xml');
                    const deeplinkTag = xmlDoc.getElementsByTagName('deeplink')[0];
                    if (deeplinkTag){
                        const szName = deeplinkTag.getAttribute('text');
                        const szHref:any = deeplinkTag.getAttribute('href');

                        const deeplink = decodeDeeplink(szHref);
                        let isEqual = deeplink.id == card.id;
                        if (deeplink.childId){
                            isEqual = deeplink.childId == card.id;
                        }
                        if (/*(deeplink.childType == 'card' || deeplink.childType == 'journal') && */isEqual){
                            const node = {
                                key:generateUUID2(),
                                title:item.name || t("Untitled"),
                                icon:item.type == 'card'?<IconLinkNote/>:<IconLinkJournal/>,
                                children:[],
                                deeplink:{
                                    id:item.id
                                },
                                type:item.type
                            }
                            arrayBackLinks.push(node);
                        }
                    }
                }
            }
            //找a链接
            pattern = /<a\s+[^>]*?href\s*=\s*["']noteey:\/\/open[^"'>]*["'][^>]*>/gi
            results = item.doc.match(pattern);
            if (results){
                const parser = new DOMParser();
                for (let i=0;i<results.length;i++){
                    const szStr = results[i];
                    const xmlDoc = parser.parseFromString(szStr,'text/xml');
                    const deeplinkTag = xmlDoc.getElementsByTagName('a')[0];
                    if (deeplinkTag){
                        const szHref:any = deeplinkTag.getAttribute('href');
                        const deeplink = decodeDeeplink(szHref);
                        let isEqual = deeplink.id == card.id;
                        if (deeplink.childId){
                            isEqual = deeplink.childId == card.id;
                        }
                        if (/*(deeplink.childType == 'card' || deeplink.childType == 'journal') && */isEqual){
                            const node = {
                                key:generateUUID2(),
                                title:item.name || t("Untitled"),
                                icon:item.type == 'card'?<IconLinkNote/>:<IconLinkJournal/>,
                                children:[],
                                deeplink:{
                                    id:item.id
                                },
                                type:item.type
                            }
                            arrayBackLinks.push(node);
                        }
                    }
                }
            }
        }


        // for (let i=0;i<arrayCards.length;i++){
        //     const item = arrayCards[i];
        //     if (item.id == card.id)continue;
        //
        //     item.doc = await getCardDoc(item.id);
        //     let pattern = /<deeplink(.*?)<\/deeplink>/g;
        //     let results = item.doc.match(pattern);
        //     if (results){
        //         const parser = new DOMParser();
        //         for (let i=0;i<results.length;i++){
        //             //获取标题和链接
        //             const szStr = results[i];
        //             const xmlDoc = parser.parseFromString(szStr,'text/xml');
        //             const deeplinkTag = xmlDoc.getElementsByTagName('deeplink')[0];
        //             if (deeplinkTag){
        //                 const szName = deeplinkTag.getAttribute('text');
        //                 const szHref:any = deeplinkTag.getAttribute('href');
        //
        //                 const deeplink = decodeDeeplink(szHref);
        //                 let isEqual = deeplink.id == card.id;
        //                 if (deeplink.childId){
        //                     isEqual = deeplink.childId == card.id;
        //                 }
        //                 if (/*(deeplink.childType == 'card' || deeplink.childType == 'journal') && */isEqual){
        //                     const node = {
        //                         key:generateUUID2(),
        //                         title:item.name || t("Untitled"),
        //                         icon:item.type == 'card'?<IconLinkNote/>:<IconLinkJournal/>,
        //                         children:[],
        //                         deeplink:{
        //                             id:item.id
        //                         },
        //                         type:item.type
        //                     }
        //                     arrayBackLinks.push(node);
        //                 }
        //             }
        //         }
        //     }
        //
        //     //找a链接
        //     pattern = /<a\s+[^>]*?href\s*=\s*["']noteey:\/\/open[^"'>]*["'][^>]*>/gi
        //     results = item.doc.match(pattern);
        //     if (results){
        //         const parser = new DOMParser();
        //         for (let i=0;i<results.length;i++){
        //             const szStr = results[i];
        //             const xmlDoc = parser.parseFromString(szStr,'text/xml');
        //             const deeplinkTag = xmlDoc.getElementsByTagName('a')[0];
        //             if (deeplinkTag){
        //                 const szHref:any = deeplinkTag.getAttribute('href');
        //                 const deeplink = decodeDeeplink(szHref);
        //                 let isEqual = deeplink.id == card.id;
        //                 if (deeplink.childId){
        //                     isEqual = deeplink.childId == card.id;
        //                 }
        //                 if (/*(deeplink.childType == 'card' || deeplink.childType == 'journal') && */isEqual){
        //                     const node = {
        //                         key:generateUUID2(),
        //                         title:item.name || t("Untitled"),
        //                         icon:item.type == 'card'?<IconLinkNote/>:<IconLinkJournal/>,
        //                         children:[],
        //                         deeplink:{
        //                             id:item.id
        //                         },
        //                         type:item.type
        //                     }
        //                     arrayBackLinks.push(node);
        //                 }
        //             }
        //         }
        //     }
        // }

        return arrayBackLinks;
    }

    //项目的link*****
    async function statProjectLink(project,arrayLinkNodes,childNode,szId){
        if (!project.doc){
            const doc = await getNoteJsonDoc(project.id);
            project.doc = doc;
        }
        let jsonDoc = (project.doc);
        if (isString(jsonDoc)){
            jsonDoc = JSON.parse(jsonDoc);
        }
        await loopAllNodeAsync(jsonDoc.canvas,async (node)=>{
            if (node.drawJson?.elements){
                const arrayProjectLinks = node.drawJson.elements.filter(p=>isProjectLinkElement(p));
                for (let j=0;j<arrayProjectLinks.length;j++){
                    const projectLinkElement = arrayProjectLinks[j];
                    const projectLink:any = await getNoteById(projectLinkElement.customData.projectId,false);


                    let szTitle = projectLink.name || t("Untitled");
                    if (projectLinkElement.customData.boardId){
                        let doc = await getNoteJsonDoc(projectLinkElement.customData.projectId);
                        if (doc){
                            const board = doc.canvas.find(p=>p.key == projectLinkElement.customData.boardId);
                            if (board){
                                szTitle += " / "+board.title;
                            }
                        }
                        doc = null;
                    }
                    const node = {
                        key:projectLink.id,
                        title:szTitle,
                        icon:<IconProject/>,
                        children:[],
                        element:projectLinkElement
                    };
                    if (arrayLinkNodes){
                        arrayLinkNodes.push(node);
                    }else{
                        childNode.children.push(node);
                    }

                    if (projectLink.id != project.id && mProjectLinkIds.current.includes(projectLink.id)){
                        if (project.id != szId){
                            project.doc = null;
                        }
                        mProjectLinkIds.current.push(projectLink.id);
                        await statProjectLink(projectLink,null,node,szId);
                    }
                }
            }
        })
    }

    async function backProjectList(project:any){
        const arrayBackLinks:any = [];
        const arrayProject:any = await getNoteList();
        for (let i=0;i<arrayProject.length;i++){
            const item = arrayProject[i];
            if (item.id == project.id)continue;

            const doc = await getNoteDoc(item.id);
            if (!doc || !doc.doc)continue;
            const json = JSON.parse(doc.doc);
            if (json?.canvas){
                let bFinished = false;
                loopAllNode(json.canvas,(canvas)=>{
                    if (!bFinished && canvas.drawJson?.elements){
                        const ele = canvas.drawJson.elements.find(p=>p.customData?.projectId == project.id);
                        if (ele){
                            const parents = findNodeWithParents(json.canvas,canvas.key);
                            let szBoardName = '';
                            if (parents?.parents){
                                for (let pp=0;pp<parents.parents.length;pp++){
                                    szBoardName = parents.parents[pp].title + ' / ';
                                }
                            }
                            arrayBackLinks.push({
                                key:item.id,
                                title:(item.name || t("Untitled")) + " / " + szBoardName + canvas.title,
                                icon:<IconProject/>,
                                children:[],
                                element:{customData:{projectId:item.id,boardId:canvas.key,elementId:ele.id}},//projectId指向这个项目...
                                deeplink:{
                                    id:item.id,
                                    boardId:canvas.key
                                }
                            })
                            bFinished = true;
                        }
                    }
                })
            }
        }
        return arrayBackLinks;
    }
    /**
     * card选择
     */
    const onSelect:TreeProps["onSelect"] =((selectedKeys:any, info) => {
        if (info.node?.type == 'card' || info.node?.type == 'journal'){
            if (info.node.deeplink.targetCardId && info.node.deeplink.blockId) {
                document.dispatchEvent(
                    new CustomEvent('blockLinkClick', {
                        detail: {
                            noteId: info.node.deeplink.id,
                            blockId: info.node.deeplink.blockId,
                            blockType: info.node.deeplink.blockType ?? 'paragraph',
                        },
                    })
                );
            }else{
                postMessage(EVENT_OPEN_LIBRARY_ITEM,{id:info.node.deeplink.id,deeplink:info.node.deeplink})
            }
        }
        if (type == 'project' || info.node?.type == 'project'){
            // postMessage(EVENT_NAVIGATE_DEEPLINK,{element:info.node.element});
            getNoteById(info.node.key).then(projectInfo=>{
                window.navigate(getDrawPath(),{noteData:projectInfo,searchKey:''})
            })
        }
    });

    /**
     * 刷新textarea的高度
     * @param event
     */
    const refreshTextAreaHeight = (textArea,focus)=>{
        if (!textArea)return;
        textArea.style.height = '0px';
        let nHeight = textArea.scrollHeight;
        if (nHeight < 32) {
            nHeight = 32;
        }
        if (focus){
            if (nHeight > 140) {
                nHeight = 140;//大概6行的高度
                textArea.style.overflow='auto';
            }else {
                textArea.style.overflow='hidden';
            }
        }else{
            if (nHeight > 50) {
                nHeight = 50;//大概6行的高度
                textArea.style.overflow='hidden';
            }else {
                textArea.style.overflow='hidden';
            }
        }

        textArea.style.height = nHeight + 'px';
    }

    return(
        <div style={{overflowX:(props.from == 'EditorBottom' || props.from == "RightSlider")?'':'hidden'}}>

            {/*<span className={'dialog-title'}>{data?.name}</span>*/}
            {/*<div className={'line mt-12'} style={{margin: '12px -22px'}}></div>*/}


            <div className={'mt-6'} style={{paddingTop: '6px'}}>
                {
                    // (hasInfoNotes(type)) &&
                    <>
                    <textarea ref={txtAreaRef} className={'textarea-style text-truncate'} value={data?.infoNotes || ''}
                              placeholder={t("InfoPlaceHolderNotes")} style={{display: '-webkit-box',border:'1px solid var(--line-color-44)'}}
                              onChange={(event) => {
                                  refreshTextAreaHeight(event.currentTarget, true);
                                  //更新到库...
                                  const ddd = {...data};
                                  ddd.infoNotes = event.currentTarget.value;
                                  setData(ddd);
                                  //更新.
                                  if (type == 'project') {
                                      updateNote(ddd);
                                      //还要更新drawIndex中的。。。。
                                      if (window.onUpdateInfoNotes) {
                                          window.onUpdateInfoNotes(ddd);
                                      }
                                  }else if (data.type == 'board') {
                                      updateBoard(ddd);
                                  }else {
                                      updateCard(ddd);
                                      //刷新canvas中的infoNotes...
                                      window.globalRefreshList('refreshRenderCanvasNote_', ddd);
                                      window.globalRefreshList('refreshLibraryInfos_',ddd,{guid:selfGuid.current});
                                      if (data.type == 'card' || data.type == 'journal') {
                                          window.globalRefreshList('updateInfoNotes_',ddd);
                                      }
                                  }
                              }} onFocus={(event) => {
                        event.currentTarget.style.border = '1px solid ' + getInputBorderColor();
                        event.currentTarget.classList.remove('text-truncate');
                        refreshTextAreaHeight(event.currentTarget, true);
                    }} onBlur={(event) => {
                        event.currentTarget.scrollTop = 0;
                        event.currentTarget.style.border = '1px solid var(--input-border-color)';
                        event.currentTarget.classList.add('text-truncate');
                        refreshTextAreaHeight(event.currentTarget, false);
                    }}/>
                        <div className={'flex-row-vertical-center input-border mt-8'} style={{border:'1px solid var(--line-color-44)'}}  onFocus={(event)=>{
                            event.currentTarget.style.border = '1px solid ' + getInputBorderColor();
                        }} onBlur={(event)=>{
                            event.currentTarget.style.border = '1px solid var(--input-border-color)';
                        }}>
                            {
                                (isEditInfoUrl || !isDeepLink(data?.infoUrl)) ?
                                    <input id={`input-info-url-${data?.id}`} className={'input-none'} style={{flexGrow: '1',}} value={data?.infoUrl || ''}
                                           placeholder={t("InfoPlaceHolderHttps")} onChange={(event) => {
                                        const ddd = {...data};
                                        ddd.infoUrl = event.currentTarget.value;
                                        setData(ddd);
                                        if (type == 'project') {
                                            updateNote(ddd);
                                            if (window.onUpdateInfoNotes) {
                                                window.onUpdateInfoNotes(ddd);
                                            }
                                        }else if (data.type == 'board') {
                                            updateBoard(ddd);
                                        } else {
                                            updateCard(ddd);
                                            window.globalRefreshList('refreshLibraryInfos_', ddd, {guid: selfGuid.current});
                                            if (data.type == 'card' || data.type == 'journal') {
                                                window.globalRefreshList('updateInfoNotes_', ddd);
                                            }
                                        }
                                    }} onBlur={(e)=>{
                                        setIsEditInfoUrl(false);
                                    }}/>:<CustomDeeplink url={data?.infoUrl} onItemClick={()=>{
                                        setIsEditInfoUrl(true);

                                        if (inputDivRef.current){
                                            inputDivRef.current.style.border = '1px solid ' + getInputBorderColor();
                                        }
                                        setTimeout(()=>{
                                            const input = document.getElementById(`input-info-url-${data?.id}`);
                                            if (input){
                                                input?.setSelectionRange(0,0)
                                                input?.focus();
                                            }
                                        },200)

                                    }}/>
                            }


                            {
                                data?.infoUrl &&
                                <img className={'img-16 cursor-pointer'} style={{flexShrink: '0'}}
                                     src={getImagePathWithThemeSvg('link_open')} onClick={async () => {
                                    if (!data.infoUrl) return;
                                    if (isDeepLink(data.infoUrl)) {
                                        const deeplink = decodeDeeplink(data.infoUrl);
                                        if (deeplink.type == 'library' || deeplink.type == 'highlight') {
                                            postMessage(EVENT_OPEN_LIBRARY_ITEM, {
                                                id: deeplink.id,
                                                from: FROM_LIBRARY,
                                                deeplink: deeplink,
                                                selectedId: deeplink.childId,
                                                inSlider: true,
                                            })
                                        } else {
                                            //转到项目
                                            const linkInfo: any = await deepLinkToLinkInfo(deeplink);
                                            linkInfo.isLink = true;
                                            postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, {
                                                linkInfo: linkInfo,
                                                inSlider: false
                                            });
                                        }
                                    } else {
                                        if (isSupportLink(data.infoUrl)){
                                            ipcInvoke('open-url-withwhen',data.infoUrl)
                                        }else{
                                            let szUrl = data.infoUrl;
                                            if (!szUrl?.startsWith('http')) {
                                                szUrl = 'https://' + data.infoUrl;
                                            }
                                            ipcSend('open-url', szUrl)
                                        }
                                    }
                                }}/>
                            }
                        </div>
                        <div className={'line mt-12'} style={{margin: '12px -22px 12px -36px'}}></div>
                    </>
                }

                <span className={'dialog-title'}>{t("Details")}</span>

                {
                    arrayAttributes.map(p => {
                        return (
                            <div key={p.key + p.label} className={'info-item'}  style={{
                                display: 'flex',
                                flexDirection: 'row',
                                minHeight: '50px',
                                alignItems: 'center',
                            }}>
                                <img className={'img-26'} src={getImagePathWithTheme(p.icon)}/>
                                {/*//左边的属性名称*/}
                                <div className={'flex-col ml-8'} style={{minWidth: '140px',}}>
                                    {/*{*/}
                                    {/*    p.image &&*/}
                                    {/*    <img className={'img-16 mr-10'} src={imgPathPerfix() + p.image}/>*/}
                                    {/*}*/}

                                    <span style={{
                                        color: 'var(--info-label-color)',
                                        display: 'block',
                                    }}>{p.label}</span>

                                    {
                                        p.key != 'projects' &&
                                        <span className={'font-family-medium mt-2'}
                                              style={{}}>{p.value}</span>
                                    }
                                </div>
                            </div>
                        )
                    })
                }

                {
                    //如果是文件，显示路径
                    data?.fileName &&
                    <div className={'info-item'} key={'location'} style={{
                        display: 'flex',
                        flexDirection: 'row',
                        minHeight: '38px',
                        marginTop: '12px',
                        alignItems: 'center'
                    }}>
                        <img className={'img-26'} src={getImagePathWithTheme('info_folder.svg')}/>


                        <div className={'flex-col ml-8'} style={{flexGrow: '1',overflow:'hidden'}}>
                            {/*//左边的属性名称*/}
                            <div className={''} style={{minWidth: '140px'}}>
                                <span style={{
                                    color: 'var(--color-9A9A9A)',
                                    display: 'block'
                                }}>{(isSupportVideoAnnoUrl(data.fileName) || data.type == 'webLink') ? t("Link") : t("Location")}</span>
                            </div>

                            <span className={'font-family-medium mt-2 text-truncate'}
                                  style={{
                                      display:'block'
                                      // marginLeft: '2px',
                                  }}>{((isSupportVideoAnnoUrl(data.fileName) || data.type == 'webLink') ? '' : (data.isAbsolutePath ? '' : localStorage.getItem(KEY_FILE_DIR))) + data.fileName}</span>
                        </div>

                        {/*文字太长总是被挤走。。。。。为什么，为什么这种东西老是无效。flexShrink:'0'flexShrink:'0'flexShrink:'0'flexShrink:'0'flexShrink:'0'flexShrink:'0'flexShrink:'0'flexShrink:'0'*/}
                        <img style={{flexShrink: '0', flexBasis: '1'}}
                             className={'ml-12 img-16 cursor-pointer mr-16'} onClick={() => {
                            if (isSupportVideoAnnoUrl(data.fileName) || data.type == 'webLink') {
                                ipcSend('open-url', data.fileName);
                            } else {
                                ipcSend("show-in-exporler", (data.isAbsolutePath ? '' : localStorage.getItem(KEY_FILE_DIR)) + data.fileName)
                            }
                        }} src={getImagePathWithTheme('link_open.svg')}/>
                    </div>
                }

                {
                    (arrayLinkDatas.length > 0 || arrayBacklinkDatas.length > 0 || arrayBeyondProjects.length > 0) &&
                    <div className={'line mt-12'} style={{margin: '12px -22px 12px -36px'}}></div>
                }


                {
                    //card....link tree   card....link tree   card....link tree
                    arrayLinkDatas.length > 0 &&
                    <>
                        {/*<div className={''} style={{width: '120%', margin: '18px -26px', height: '1px'}}></div>*/}

                        <div className={'flex-row-vertical-center'} style={{minWidth: '140px',}}>
                            {/*<img className={'img-16 mr-10'} src={imgPathPerfix() + 'info_project_gray.png'}/>*/}
                            <span className={'dialog-title'} style={{
                                // color: 'var(--color-9A9A9A)',
                                display: 'block'
                            }}>{t("Links")}</span>
                        </div>
                        <ConfigProvider
                            theme={{
                                components: {
                                    Tree: {
                                        colorPrimary: 'var(--tree-item-select-color)',
                                    }
                                }
                            }}>
                            <DirectoryTree
                                className="tree-fuck-css-left-align-info"
                                style={{
                                    margin: '8px 0 8px 12px',
                                    maxHeight: '100px',
                                    overflowY: 'auto',
                                    overflowX: 'hidden',
                                    background: 'transparent'
                                }}
                                switcherIcon={<DownOutlined/>}
                                onSelect={onSelect}
                                showIcon={true}
                                treeData={arrayLinkDatas}
                                blockNode={true}
                                titleRender={(nodeData: any) => {
                                    return (
                                        <div className='custom-element' id={nodeData.key}
                                             style={{display: "flex", width: "450px", alignItems: "center"}}>
                                            <Input className='default-font-size font-family-regular'
                                                   readOnly={true} bordered={false}
                                                   style={{
                                                       color: "var(--text-color)",
                                                       marginLeft: '0px',
                                                       paddingLeft: '0px',
                                                       whiteSpace: 'nowrap',
                                                       textOverflow: 'ellipsis',
                                                       overflow: 'hidden',
                                                       cursor: "pointer",
                                                       marginBottom: '0px',
                                                       marginTop: '1px',
                                                       fontSize: '12px',
                                                   }}
                                                   value={nodeData.title}/>
                                        </div>
                                    )
                                }}
                            />
                        </ConfigProvider>

                    </>
                }

                {
                    arrayBacklinkDatas.length > 0 &&
                    <>
                        <div className={'flex-row-vertical-center'} style={{minWidth: '140px',}}>
                            {/*<img className={'img-16 mr-10'} src={imgPathPerfix() + 'info_project_gray.png'}/>*/}
                            <span className={'dialog-title'} style={{
                                // color: 'var(--color-9A9A9A)',
                                display: 'block'
                            }}>{t("Backlinks")}</span>
                        </div>
                        <ConfigProvider
                            theme={{
                                components: {
                                    Tree: {
                                        colorPrimary: 'var(--tree-item-select-color)'
                                    }
                                }
                            }}>
                            <div>
                                <DirectoryTree
                                    className="tree-fuck-css-left-align-info"
                                    style={{
                                        margin: '8px 0 8px 12px',
                                        maxHeight: '100px',
                                        overflowY: 'auto',
                                        overflowX: 'hidden'
                                    }}
                                    switcherIcon={<CaretDownOutlined style={{color: 'black', paddingTop: '4px'}}
                                                                     rev={undefined}/>}
                                    onSelect={onSelect}
                                    showIcon={true}
                                    treeData={arrayBacklinkDatas}
                                    blockNode={true}
                                    titleRender={(nodeData: any) => {
                                        return (
                                            <div className='custom-element' id={nodeData.key}
                                                 style={{display: "flex", width: "450px", alignItems: "center"}}>
                                                <Input className='default-font-size font-family-regular'
                                                       readOnly={true} bordered={false}
                                                       style={{
                                                           color: "var(--text-color)",
                                                           marginLeft: '0px',
                                                           paddingLeft: '0px',
                                                           cursor: "pointer",
                                                           whiteSpace: 'nowrap',
                                                           textOverflow: 'ellipsis',
                                                           overflow: 'hidden',
                                                           marginBottom: '0px',
                                                           marginTop: '1px',
                                                           fontSize: '12px',
                                                       }}
                                                       value={nodeData.title}/>
                                            </div>
                                        )
                                    }}
                                />
                            </div>

                        </ConfigProvider>
                    </>

                }

                {
                    //projects.....
                    arrayBeyondProjects.length > 0 &&
                    <div style={{display: 'flex', alignItems: 'flex-start', flexDirection: 'column',marginTop:'16px'}}>
                        <div className={'flex-row-vertical-center'} style={{minWidth: '140px',}}>
                            {/*<img className={'img-16 mr-10'} src={imgPathPerfix() + 'info_project_gray.png'}/>*/}
                            <span className={'dialog-title'} style={{
                                // color: 'var(--color-9A9A9A)',
                                display: 'block'
                            }}>{t("Projects")}</span>
                        </div>
                        <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '12px', marginLeft: '22px'}}>
                            {
                                arrayBeyondProjects.map(project => {
                                    return (
                                        <div className={'flex-row-vertical-center hovered-font-blue'}
                                             style={{marginBottom: '12px', marginRight: '16px'}} onClick={async () => {
                                            closeEditor();

                                            const linkInfo = {id: project.id}
                                            //找到这个project--找到这个board--找到这个element
                                            const projectDoc = await getNoteJsonDoc(project.id);
                                            let isFinished = false;
                                            loopAllNode(projectDoc.canvas, (board) => {
                                                if (!isFinished && board?.drawJson?.elements) {
                                                    let element = null;
                                                    if (isAnnoType(data.type)) {
                                                        element = board.drawJson.elements.find(p => isAnnoElement(p) && (p.customData?.generationData?.pdfData?.id == data.id || p.customData?.generationData?.videoData?.id == data.id || p.customData?.generationData?.id == data.id));
                                                    } else {
                                                        element = board.drawJson.elements.find(p => !isAnnoElement(p) && p.customData?.generationData?.id == data.id);
                                                    }

                                                    if (element) {
                                                        linkInfo.pageId = linkInfo.boardId = board.key;
                                                        linkInfo.elementId = element.id;
                                                        isFinished = true;
                                                    }
                                                }
                                            })

                                            postMessage(EVENT_RESET_NO_SELECTED);
                                            postMessage(EVENT_REDICTER_TO_DRAW, {project, linkInfo: linkInfo})

                                            /*
                                            if (props.from == FROM_RIGHT_SIDEBAR || props.from == 'RightSlider') {

                                                //找到这个project--找到这个board--找到这个element
                                                const projectDoc = await getNoteJsonDoc(project.id);
                                                // for (let i=0;i<projectDoc.canvas.length;i++) {
                                                //     const board = projectDoc.canvas[i];
                                                //     let element = board.drawJson.elements.find(p=>!isAnnoElement(p) && p.customData?.generationData?.id == mData?.id);
                                                //     if (element) {
                                                //         linkInfo.pageId = linkInfo.boardId = board.key;
                                                //         linkInfo.elementId = element.id;
                                                //         break;
                                                //     }
                                                // }
                                                let isFinished = false;
                                                loopAllNode(projectDoc.canvas, (board) => {
                                                    if (!isFinished && board?.drawJson?.elements) {
                                                        let element = null;
                                                        if (isAnnoType(data.type)) {
                                                            element = board.drawJson.elements.find(p => isAnnoElement(p) && (p.customData?.generationData?.pdfData?.id == data.id || p.customData?.generationData?.videoData?.id == data.id || p.customData?.generationData?.id == data.id));
                                                        } else {
                                                            element = board.drawJson.elements.find(p => !isAnnoElement(p) && p.customData?.generationData?.id == data.id);
                                                        }

                                                        if (element) {
                                                            linkInfo.pageId = linkInfo.boardId = board.key;
                                                            linkInfo.elementId = element.id;
                                                            isFinished = true;
                                                        }
                                                    }
                                                })
                                                //侧栏打开这个project....
                                                if (isInDraw()) {
                                                    postMessage(EVENT_PROJECT_ON_SlIDER_RIGHT, {...linkInfo})
                                                } else {
                                                    postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, {
                                                        linkInfo: linkInfo,
                                                        inSlider: true
                                                    })
                                                }
                                            } else {
                                                postMessage(EVENT_RESET_NO_SELECTED);
                                                postMessage(EVENT_REDICTER_TO_DRAW, {project, linkInfo: linkInfo})
                                            }*/
                                        }}>
                                            <img className={'img-14'}
                                                 src={getImagePathWithTheme('info_project_black')}/>
                                            <span style={{marginLeft: '6px', marginTop: '1px'}}
                                                  className={'hovered-font-blue'}>{project.name}</span>
                                            {
                                                project.boardName &&
                                                <>
                                                    <span>&nbsp;/&nbsp;</span>
                                                    <span className={'hovered-font-blue'} onClick={() => {

                                                    }}>{project.boardName}</span>
                                                </>


                                                // project != arrayBeyondProjects[arrayBeyondProjects.length - 1] &&
                                                // <span>,</span>
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                }

                {/******************tag标签*******************/}

                {
                    data && data.isDeleted != 2 &&
                    <>
                        <div className={'line mt-12'} style={{margin: '12px -22px 12px -36px'}}></div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            marginTop: '8px'
                        }}>
                            <div className={'flex-row-vertical-center'} style={{minWidth: '140px'}}>
                                {/*<span style={{*/}
                                {/*    color: 'var(--color-9A9A9A)',*/}
                                {/*    width: '16px',*/}
                                {/*    marginLeft: '1px',*/}
                                {/*    fontSize: '18px'*/}
                                {/*}}>#</span>*/}
                                <span className={'dialog-title'} style={{
                                    marginLeft: '0px',
                                    // color: 'var(--color-9A9A9A)',
                                    display: 'block', marginTop: '3px'
                                }}>{t("Tags")}</span>
                            </div>


                            {
                                arrayTags.length == 0 && !APP_WEB &&
                                <div className={'flex-row-vertical-center cursor-pointer'}
                                     style={{marginTop: '12px', marginLeft: '26px'}}
                                     onClick={() => {
                                         dialogTagManagerRef.current?.onShowDialog([data]);
                                     }}>
                                    <img className={'img-14'} src={imgPathPerfix() + ('add_gray.png')}/>
                                    <span className={'default-font-size'} style={{
                                        color: 'var(--color-9A9A9A)',
                                        marginLeft: '8px'
                                    }}>{t("Add tags") + '...'}</span>
                                </div>
                            }

                            {
                                arrayTags.length > 0 &&
                                <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '12px', marginLeft: '0px'}}>
                                    {
                                        arrayTags.map(p => {
                                            return (
                                                <div style={{
                                                    margin: '0px 12px 12px 0px',
                                                    padding: '3px 12px',
                                                    borderRadius: '100px',
                                                    height: '28px',
                                                    position: 'relative'
                                                }}
                                                     className={'flex-row-vertical-center tag default-font-size hovered-gray-radius'}
                                                     onMouseEnter={() => {
                                                         var arrayNewTags = [...arrayTags];
                                                         arrayNewTags.forEach(p => p.isHover = false);
                                                         p.isHover = true;
                                                         setArrayTags(arrayNewTags);
                                                     }} onMouseLeave={() => {
                                                    var arrayNewTags = [...arrayTags];
                                                    arrayNewTags.forEach(p => p.isHover = false);
                                                    setArrayTags(arrayNewTags);
                                                }} onClick={() => {
                                                    window.closeRightSlider();
                                                    window.navPageTag(p);
                                                }}>
                                                    <span>#{p.name}</span>
                                                    {
                                                        p.isHover &&
                                                        <img className={'img-10 cursor-pointer'}
                                                             src={getImagePathWithTheme('close_black')}
                                                             style={{
                                                                 marginLeft: '6px',
                                                                 position: 'absolute',
                                                                 right: '8px',
                                                                 top: '8px'
                                                             }} onClick={(e) => {
                                                            e.stopPropagation();
                                                            //remove...
                                                            var arrayNewTags = [...arrayTags];
                                                            let nIndex = arrayNewTags.indexOf(p);
                                                            arrayNewTags.splice(nIndex, 1);
                                                            setArrayTags(arrayNewTags);

                                                            nIndex = data.tags.indexOf(p.name);
                                                            if (nIndex >= 0) {
                                                                data.tags.splice(nIndex, 1);
                                                            }
                                                            if (mData) {
                                                                //这里面的变量真是，各种不一致。。。真是无语了。。。。
                                                                nIndex = mData.tags.indexOf(p.name);
                                                                if (nIndex >= 0) {
                                                                    mData.tags.splice(nIndex, 1);
                                                                }
                                                            }

                                                            if (type == 'project') {
                                                                updateNote(data).then(res => {
                                                                    postMessage(EVENT_NOTE_CHANGED);
                                                                })
                                                            } else {
                                                                updateCard(data, false).then(res => {
                                                                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                                                                })
                                                            }
                                                        }}></img>
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                    <div className={'tag hovered-gray-radius'} style={{
                                        margin: '0px 12px 12px 0px',
                                        padding: '3px 12px',
                                        borderRadius: '100px',
                                        height: '28px',
                                        position: 'relative',
                                        display: 'flex', justifyContent: 'center', alignItems: 'center'
                                    }} onClick={() => {
                                        dialogTagManagerRef.current?.onShowDialog([data]);
                                    }}>
                                        <img className={'img-16'} src={getImagePathWithTheme('add_black')}/>
                                    </div>
                                </div>
                            }

                        </div>
                    </>
                }

                {/*自定义属性*/}
                <>
                    {/*<div className={'line mt-12'} style={{margin: '12px -22px 12px -36px'}}></div>*/}
                    {/*<div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start',marginBottom:'10px'}}>*/}
                    {/*    <div className={'flex-row-vertical-center'} style={{minWidth: '140px'}}>*/}
                    {/*<span className={'dialog-title'} style={{*/}
                    {/*    marginLeft: '0px',*/}
                    {/*    // color: 'var(--color-9A9A9A)',*/}
                    {/*    display: 'block', marginTop: '3px'*/}
                    {/*}}>{t("Propertyies")}</span>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {
                        data &&
                        <CustomPropertyInfo data={data}/>
                    }

                </>

            </div>

            <DialogTagManager ref={dialogTagManagerRef} from={type == "project" ? "project" : "library"}
                              onDismissCallback={async (isTagChange: boolean) => {
                                  if (isTagChange) {
                                      //标签更改了，需要刷新数据....
                                      if (type == "project") {
                                          const newData = await getNoteById(data.id);
                                          setData(newData);
                                          refreshTag(newData);
                                          postMessage(EVENT_NOTE_CHANGED);
                                      } else {
                                          const newCard = await getCardById(data.id);
                                          setData(newCard);
                                          refreshTag(newCard);
                                          postMessage(EVENT_REFRESH_LIBRARY_LIST);
                                          if (window.refreshTag) {
                                              window.refreshTag(newCard);
                                          }
                                      }
                                  }
                              }}/>
        </div>
    )
})

export default LibraryInfos;


























